
<nav class="navbar navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img src="721-white.png" alt="" width="50">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" routerLink="">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="templates">Templates</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="isf">ISF Filings</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="user">Me</a>
                </li>

            </ul>

            <span class="navbar-text me-2" *ngIf="isLoggedIn">
                <span class="m-1">{{userProfile?.username}}</span>
            </span>
            <span class="navbar-text me-2 small">
                <span><a href="#" (click)="logout()">Logout</a></span>
            </span>
            <span class="navbar-text small">
                    <span><a href="#" (click)="reset()">PW Reset</a></span>
            </span>
        </div>
    </div>
</nav>
